import {
    SubmitButton,
    VerifyEmail,
    VerifyEmailDescription,
    VerifyEmailInput,
    VerifyEmailTitle,
    VerifyEmailTitleDescWrapper,
} from "@/components/Auth/VerifyEmailModal/VerifyEmailModal.styled";
import VerifyEmailAction from "@/components/Auth/VerifyEmailModal/VerifyEmailAction";
import ResendCodeButton from "@/components/Auth/ResendCodeButton/ResendCodeButton";
import {useTranslations} from "next-intl";

const VerifyEmailModal = () => {
    const t = useTranslations('Auth.SignUpForm.VerifyEmail')
    const tm = useTranslations('Main.Buttons')
    const tf = useTranslations('Fields')

    return (
        <VerifyEmail name={'verify-email'} closable={false} closeIcon={null}>
            <VerifyEmailTitleDescWrapper>
                <VerifyEmailTitle>
                    {t('title')}
                </VerifyEmailTitle>
                <VerifyEmailDescription>
                    {t('text')}
                </VerifyEmailDescription>
            </VerifyEmailTitleDescWrapper>
            <VerifyEmailAction>
                <VerifyEmailInput
                    name={'code'}
                    label={tf('code')}
                    variant={'convex'}
                />
                <ResendCodeButton />
                <SubmitButton type={'submit'} color={'secondaryDark'}>{tm('submit')}</SubmitButton>
            </VerifyEmailAction>
        </VerifyEmail>
    );
};

export default VerifyEmailModal;